import {call, put} from "typed-redux-saga";
import {ISagaAction} from "modules/types";
import {
	IUserBackdoorLoginPayload,
	userBackdoorLoginFailed,
	userBackdoorLoginSuccess,
	requestCurrentUserSuccess,
	requestCurrentUserFailed,
	userPreregistrationSuccess,
	userPreregistrationFailed,
} from "modules/actions";
import {Api, ApiError} from "modules/utils/Api";
import PersistStorage from "modules/utils/PersistStorage";

export const userBackdoorLoginSaga = function* ({payload}: ISagaAction<IUserBackdoorLoginPayload>) {
	try {
		const response = yield* call(Api.Auth.backdoor, payload);
		ApiError.CHECK(response);

		const {user} = response.success;
		PersistStorage.SET("is_authenticated", "true");

		yield* put(userBackdoorLoginSuccess(user));
	} catch (err) {
		const {message} = err as Error;
		yield* put(userBackdoorLoginFailed(message));
	}
};

export const userPreregistrationSaga = function* ({
	payload,
}: ISagaAction<IUserBackdoorLoginPayload>) {
	try {
		const response = yield* call(Api.Auth.preregistration, payload);
		ApiError.CHECK(response);
		PersistStorage.SET("is_preregistration", "true");

		yield* put(userPreregistrationSuccess());
	} catch (err) {
		const {message} = err as Error;
		yield* put(userPreregistrationFailed(message));
	}
};

export const getCurrentUserSaga = function* () {
	try {
		const response = yield* call(Api.User.user);
		yield* put(requestCurrentUserSuccess(response.success.user));
	} catch (err) {
		yield* put(requestCurrentUserFailed());
	}
};
